import {combineReducers} from "redux";
import menu from "./menu";
import navigation from "./navigation";
import progressBar from "./progressBar";
import modalLoginAndRegister from "./modals/modalLoginAndRegister";
import modalShoppingCard from "./modals/shoppingCard/modalShoppingCard";
import modalProduct from "./modals/modalProduct";
import modalEditProfile from "./modals/modalEditProfile";
import modalMyWallet from "./modals/modalMyWallet";
import modalMyOrders from "./modals/modalMyOrders/modalMyOrders";
import modalAddAddress from "./modals/modalAddAdress";
import modalChangeAddress from "./modals/modalChangeAddress";
import submitAnOrderComment from "./modals/modalMyOrders/submitAnOrderComment";
import user from "./user/user";
import shoppingCart from "./shoppingCart";
import modalFinalizeRegistration from "./modals/modalFinalizeRegistration";
import modalSelectBaseMarket from "./modals/modalSelectBaseMarket";
import markets from "./markets/markets";
import main from "./main/mian";
import guest from "./user/guest";
import moreProducts from "./pages/moreProducts";
import modalAddPrice from "./modals/modalAddPrice";
import search from "./partials/search";
import contactUs from "./pages/contactUs";
import complaint from "./pages/complaint";
import modalEditAddress from "./modals/address/modalEditAdress";
import home from "./pages/home";
import modalGratuity from "./modals/gratuity/modalGratuity";
import modalSurvey from "./modals/modalSurvey";
import modalInvoice from "./modals/modalInvoice/modalInvoice";
import modalOrderDetails from "./modals/modalOrderDetails/modalOrderDetails";
import modalAddDiscountCode from "./modals/modalAddDiscountCode";
import modalPwaIsIos from "./modals/modalPwaIsIos";
import map from "./partials/map";
import stores from "./stores.reducers";
import modalInvitation from "./modals/modalInvitation.reducers";
import modalMyDiscounts from "./modals/modalMyDiscounts.reducers";

import modalRankGuide from "./modals/modalRankGuide";
import foodPackage from "./pages/foodPackage";
import googleAnalytics from "./googleAnalytics";
import modalMyFoodPacks from "./modals/modalMyFoodPacks.reducers";
import modalEditOrderDateTime from "./modals/editOrder/modalEditOrderDateTime";
import modalEditOrderDescGratuity from "./modals/editOrder/modalEditOrderDescGratuity";
import modalMyCarrotWallet from "./modals/modalMyCarrotWallet";


export default combineReducers({
    modalProduct,
    shoppingCart,
    modalShoppingCard,
    modalLoginAndRegister,
    modalEditProfile,
    modalMyWallet,
    modalMyOrders,
    modalAddAddress,
    modalChangeAddress,
    modalFinalizeRegistration,
    submitAnOrderComment,
    modalSelectBaseMarket,
    modalAddPrice,
    progressBar,
    navigation,
    menu,
    user,
    guest,
    markets,
    main,
    moreProducts,
    search,
    contactUs,
    modalEditAddress,
    home,
    modalGratuity,
    complaint,
    modalSurvey,
    modalInvoice,
    modalOrderDetails,
    modalAddDiscountCode,
    modalPwaIsIos,
    map,
    /*START NEW REDUCERS*/
    stores,
    modalInvitation,
    modalMyDiscounts, 

    modalRankGuide,
    foodPackage,
    googleAnalytics,
    modalMyFoodPacks, 
    modalEditOrderDateTime, 
    modalEditOrderDescGratuity, 
    modalMyCarrotWallet,
});
